import React from 'react';
import googleSheets from '../../images/integrations/google-sheets.svg';
import IntegrationBot from '../../components/integrationn/index';

const GoogleSheets = () => <IntegrationBot botLogo={googleSheets} botName={'Google Sheets'} />;

export default GoogleSheets;
